import React, { Component } from 'react';
import axios from 'axios';
import {PutData,GetData, PostData} from '../../services/PostData';
import {apiConfig} from "../../config/api"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import dateFormat from 'dateformat';
import Configdata from '../../config.json';
import { toast } from 'react-toastify';
import { Modal, Button } from "react-bootstrap";
import dueDateImage from '../../assets/images/due-date.png';

const errorMsg = {
  color: '#cc0000',
  marginBottom:'12px'
};
const successMsg = {
  color: '#00ff00',
  fontSize:'16px'
};

const styles = {
	listItem: {
	  display: "flex",
	  justifyContent: "space-between",
	  alignItems: "center",
	  padding: "4px",
	  borderBottom: "1px solid #ddd",
	},
	name: {
	  flex: 2, // Takes more space for longer text
	  whiteSpace: "nowrap", // Prevents text from breaking onto the next line
	  overflow: "hidden",
	//   textOverflow: "ellipsis", // Truncates if too long
	  textWrap: 'auto',
	  marginRight: "10px", // Adds spacing between fields
	},
	date: {
	  flex: 1, // Smaller fixed width for the date
	  textAlign: "left", // Keeps date aligned to the left
	  whiteSpace: "nowrap", // Prevents date from wrapping
	  marginRight: "10px",
	},
	deleteButton: {
	//   backgroundColor: "#dc3545",
	  color: "#fff",
	  border: "none",
	  padding: "6px 8px",
	  borderRadius: "4px",
	  cursor: "pointer",
	},
  };

toast.configure()
export default class EditOrganization extends Component {
    state = {
	   // hours_renew_date: new Date()
	};
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.submit = this.submit.bind(this);
        this.state = {
        org_name: '',
        street: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        twitter: '',
        linkedin: '',
        logo: '',
        subscriber:'',
        boxfolderid:'',
        fields:'',
        errors:'',
        success:'',
        isshowing_subscription_hour:false,
        isshowing_org_credit:false,
        subscription_hour:'',
        totalavailable_hours:'',
        subscription_hour_rate:'',
        remaining_hours:'',
        credits:'',
        nick_name: '',
        website: '',
        hours_renew_date:'',
        subscriberType: '',
        freshbookprofileid:'',
        vimeo_uri:'',
        dates: [
			{ date: 1 },
			{ date: 2 },
			{ date: 3 },
			{ date: 4 },
			{ date: 5 },
			{ date: 6 },
			{ date: 7 },
			{ date: 8 },
			{ date: 9 },
			{ date: 10 },
			{ date: 11 },
			{ date: 12 },			
			{ date: 13 },
			{ date: 14 },
			{ date: 15 },
			{ date: 16 },
			{ date: 17 },
			{ date: 18 },
			{ date: 19 },
			{ date: 20 },
			{ date: 21 },
			{ date: 22 },
			{ date: 23 },
			{ date: 24 },
			{ date: 25 },
			{ date: 26 },
			{ date: 27 },
			{ date: 28 },			
		],
        subscriberTypeList: [
			{ id: 1, type: 'Subscriber', value: 'subscriber' },
			{ id: 2, type: 'Demo', value: 'demo' },
			{ id: 3, type: 'Per-project', value: 'per-project' },
			{ id: 4, type: 'Prospects', value: 'prospects' },
			{ id: 5, type: 'Leads', value: 'leads' },
			{ id: 6, type: 'Subscriber - Canceled', value: 'subscriber-canceled' },
		],
        note: '',
		dueDate: '',
		teamMemberList: [],
		selectedTeamMemberId: '',
		showFollowUpTaskModal: false,
		teammember: '',
        isAlreadyAssignedTask: false,
        teamUserError: '',
		dueDateError: '',
		assignedUser: '',
        taskDetail: {},
        industries:[
			'Healthcare and Social Assistance',
			'Technology (Information Technology)',
			'Finance and Insurance',
			'Retail Trade',
			'Construction',
			'Manufacturing',
			'Professional and Business Services',
			'Real Estate, Rental, and Leasing',
			'Education Services',
			'Transportation and Warehousing',
			'Energy (Utilities and Renewables)',
			'Telecommunications',
			'Agriculture and Forestry',
			'Hospitality and Tourism',
			'Aerospace and Defense',
			'Entertainment and Media',
			'Food and Beverage Industry',
			'Pharmaceuticals and Biotechnology',
			'Automotive',
			'Others'
		],
		selectedIndustry: '',
		selectedIndustryWithLowerCase:'',
		otherIndustry: '',
		subIndustries: [
			{ 
			  label: 'Healthcare and Social Assistance',
			  subcategories: [
				'Hospitals',
				'Medical practices',
				'Nursing homes',
				'Social services'
			  ]
			},
			{ 
			  label: 'Technology (Information Technology)',
			  subcategories: [
				'Software development',
				'Hardware manufacturing',
				'Cloud computing',
				'Cybersecurity'
			  ]
			},
			{ 
			  label: 'Finance and Insurance',
			  subcategories: [
				'Banking',
				'Investment services',
				'Insurance companies'
			  ]
			},
			{ 
			  label: 'Retail Trade',
			  subcategories: [
				'Brick-and-mortar stores',
				'E-commerce'
			  ]
			},
			{ 
			  label: 'Construction',
			  subcategories: [
				'Residential projects',
				'Commercial projects',
				'Infrastructure projects'
			  ]
			},
			{ 
			  label: 'Manufacturing',
			  subcategories: [
				'Durable goods',
				'Nondurable goods'
			  ]
			},
			{ 
			  label: 'Professional and Business Services',
			  subcategories: [
				'Legal services',
				'Consulting',
				'Engineering',
				'Marketing'
			  ]
			},
			{ 
			  label: 'Real Estate, Rental, and Leasing',
			  subcategories: [
				'Residential',
				'Commercial property sales',
				'Management',
				'Leasing'
			  ]
			},
			{ 
			  label: 'Education Services',
			  subcategories: [
				'Public institutions',
				'Private institutions',
				'Universities',
				'Training programs'
			  ]
			},
			{ 
			  label: 'Transportation and Warehousing',
			  subcategories: [
				'Logistics',
				'Trucking',
				'Shipping',
				'Warehousing'
			  ]
			},
			{ 
			  label: 'Energy (Utilities and Renewables)',
			  subcategories: [
				'Electricity',
				'Natural gas',
				'Solar',
				'Wind',
				'Other renewables'
			  ]
			},
			{ 
			  label: 'Telecommunications',
			  subcategories: [
				'Wireless',
				'Internet',
				'Cable services'
			  ]
			},
			{ 
			  label: 'Agriculture and Forestry',
			  subcategories: [
				'Farming',
				'Fishing',
				'Forestry',
				'Agribusiness',
			  ]
			}, 
			{ 
			  label: 'Hospitality and Tourism',
			  subcategories: [
				'Hotels',
				'Resorts',
				'Travel services'
			  ]
			},
			{ 
			  label: 'Aerospace and Defense',
			  subcategories: [
				'Aircraft manufacturing',
				'Defense contractors',
				'Space exploration'
			  ]
			},
			{ 
			  label: 'Entertainment and Media',
			  subcategories: [
				'Film',
				'Music',
				'Publishing',
				'Broadcasting'
			  ]
			},
			{ 
			  label: 'Food and Beverage Industry',
			  subcategories: [
				'Restaurants',
				'Food processing',
				'Beverage production'
			  ]
			},
			{ 
			  label: 'Pharmaceuticals and Biotechnology',
			  subcategories: [
				'Drug development',
				'Medical research',
				'Biotechnology companies'
			  ]
			},
			{ 
			  label: 'Automotive',
			  subcategories: [
				'Vehicle manufacturing',
				'Parts',
				'Sales'
			  ]
			}
		],
		fiscalYearStart: '', // Selected fiscal year start month
		months: [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		],
		opportunities: [], // List of video opportunities
		opportunityName: '', // Name of the current opportunity
		reminderDate: '',
        suggestions: [],
		street: '',
		isSuggestionsVisible: false,
        usStates: [
			{ name: "Alabama", code: "AL" },
			{ name: "Alaska", code: "AK" },
			{ name: "Arizona", code: "AZ" },
			{ name: "Arkansas", code: "AR" },
			{ name: "California", code: "CA" },
			{ name: "Colorado", code: "CO" },
			{ name: "Connecticut", code: "CT" },
			{ name: "Delaware", code: "DE" },
			{ name: "Florida", code: "FL" },
			{ name: "Georgia", code: "GA" },
			{ name: "Hawaii", code: "HI" },
			{ name: "Idaho", code: "ID" },
			{ name: "Illinois", code: "IL" },
			{ name: "Indiana", code: "IN" },
			{ name: "Iowa", code: "IA" },
			{ name: "Kansas", code: "KS" },
			{ name: "Kentucky", code: "KY" },
			{ name: "Louisiana", code: "LA" },
			{ name: "Maine", code: "ME" },
			{ name: "Maryland", code: "MD" },
			{ name: "Massachusetts", code: "MA" },
			{ name: "Michigan", code: "MI" },
			{ name: "Minnesota", code: "MN" },
			{ name: "Mississippi", code: "MS" },
			{ name: "Missouri", code: "MO" },
			{ name: "Montana", code: "MT" },
			{ name: "Nebraska", code: "NE" },
			{ name: "Nevada", code: "NV" },
			{ name: "New Hampshire", code: "NH" },
			{ name: "New Jersey", code: "NJ" },
			{ name: "New Mexico", code: "NM" },
			{ name: "New York", code: "NY" },
			{ name: "North Carolina", code: "NC" },
			{ name: "North Dakota", code: "ND" },
			{ name: "Ohio", code: "OH" },
			{ name: "Oklahoma", code: "OK" },
			{ name: "Oregon", code: "OR" },
			{ name: "Pennsylvania", code: "PA" },
			{ name: "Rhode Island", code: "RI" },
			{ name: "South Carolina", code: "SC" },
			{ name: "South Dakota", code: "SD" },
			{ name: "Tennessee", code: "TN" },
			{ name: "Texas", code: "TX" },
			{ name: "Utah", code: "UT" },
			{ name: "Vermont", code: "VT" },
			{ name: "Virginia", code: "VA" },
			{ name: "Washington", code: "WA" },
			{ name: "West Virginia", code: "WV" },
			{ name: "Wisconsin", code: "WI" },
			{ name: "Wyoming", code: "WY" }
		],
        opportunityMonth: '',
        orgContactList: [],
        selectedOrgContact: '',
        selectedOrgContactId: '',
        }

        this.inputRef = React.createRef();
        this.suggestionsRef = React.createRef();
        this.isSubscriberChange = this.isSubscriberChange.bind(this);
        this.onChangeHandler = this.onChangeHandler.bind(this);
    }
    onChangeHandler=event=>{
        this.setState({
        'logo': event.target.files[0],
        loaded: 0,
        })
    }
    handleChange = date => {
        console.log('date=',date);
       const updateddate =  moment(date).format('YYYY/MM/DD');
       console.log('updateddate=',updateddate);
	    this.setState({
			hours_renew_date: updateddate
	    });
	}
    handleProjectDateChange(dateName, dateValue) {
		let hours_renew_date = this.state.hours_renew_date;
		hours_renew_date = dateValue;
		this.setState({
			hours_renew_date,			
		});
		
	}
    componentDidMount() {
        GetData('organization/'+this.props.match.params.id).then((result) => {     
        console.log('check result in edit page===',result);      
        console.log('check result in edit result.data.create_date===',result.data.create_date);    //result.data.create_date  
            this.setState({ 
            org_name: result.data.organization_name,
            street: result.data.street,
            city: result.data.city,
            state: result.data.state,
            zip: result.data.zip,
            phone: result.data.phone,
            twitter: result.data.twitter,
            linkedin: result.data.linkedin, 
            logo: result.data.logo,
            boxfolderid:result.data.boxfolderid, 
            subscriber: result.data.subscriber,
            subscriberType: result.data.subscriberType,
            nick_name:result.data.nick_name,
            website:result.data.website,
            hours_renew_date:result.data.renew_date?result.data.renew_date:'',
            //renewdate:result.data.create_date,
            freshbookprofileid:result.data.freshbook_profile_id?result.data.freshbook_profile_id:'',
            vimeo_uri:result.data.vimeo_uri,
            note: result.data.note?result.data.note:'',
            selectedIndustry: result.data.industry,
            otherIndustry: result.data.other_industry,
            fiscalYearStart: result.data.fiscal_year,
            opportunities: result.data.video_opportunities,
            //hours_renew_date: result.data.hours_renew_date?moment(result.data.hours_renew_date).format('YYYY/MM/DD') : new Date(),
            });
            if (result.data.subscriber === 'yes') {
                this.setState({ isshowing_subscription_hour: true, isshowing_org_credit: false, subscription_hour: result.data.subscription_hour, remaining_hours: result.data.remaining_hours, totalavailable_hours: result.data.totalavailable_hours, subscription_hour_rate: result.data.subscription_hour_rate });
            }
            else {
                this.setState({ isshowing_org_credit: true, isshowing_subscription_hour: false, credits: result.data.credits });
            }

            let data = {
                orgName:  result.data.organization_name
            }

            PostData('get/org/contacts', data).then(async (result) => {

                console.log('org contacts list', result);
                this.setState({orgContactList: result.contacts});
                // toast.success('Follow up task created successfully..');
            });
        });
        GetData(`followup/teamMember`).then((result) => {
            this.setState({teamMemberList: result.team })
        });
        GetData(`find/followup/task/${this.props.match.params.id}`).then((result) => {
            if(result.isTaskCreated){
                this.setState({teammember: result.task.teammember, dueDate: new Date(result.task.due_date), selectedTeamMemberId: result.task.user_id, isAlreadyAssignedTask: true, taskDetail: result.task, assignedUser: result.task.teammember })
            }
        });
        document.addEventListener('click', this.handleOutsideClick);
    }
    componentWillUnmount() {
		document.removeEventListener('click', this.handleOutsideClick);
	}

      // Handle clicks outside the input or suggestion list
	handleOutsideClick = (event) => {
		if (
		  this.inputRef.current && !this.inputRef.current.contains(event.target) &&
		  this.suggestionsRef.current && !this.suggestionsRef.current.contains(event.target)
		) {
		  this.setState({ isSuggestionsVisible: false }); // Hide suggestions
		}
	};

    handleAddressInput = (e)=>{
		// this.setState({[e.target.name]:e.target.value});

		const inputValue = e.target.value;
		this.setState({ street: inputValue });

		if (inputValue.length > 2 ) {
			this.fetchAddressSuggestions(inputValue);
		} else {
			this.setState({ suggestions: [], isSuggestionsVisible: false });
		}
	}

	handleAddressSelect =(address)=>{
		let city = '';
		let stateName = '';
		if(address.terms.length > 2) {
			const state = this.state.usStates.find(state => state.code.toLowerCase() === address.terms[address.terms.length - 2].value.toLowerCase());
			stateName = state ? state.name : address.terms[address.terms.length - 2].value;
			
			city = address.terms[address.terms.length - 3].value;
		} else if (address.terms.length == 2) {
			const state = this.state.usStates.find(state => state.code.toLowerCase() === address.terms[address.terms.length - 2].value.toLowerCase());
			stateName = state ? state.name : address.terms[address.terms.length - 2].value;
		}
		console.log('street', address.structured_formatting.main_text)
		console.log('city', city)
		console.log('state', stateName)
		this.setState({ street: address.structured_formatting.main_text, city: city, state: stateName, suggestions:[], isSuggestionsVisible: false });
	}

	fetchAddressSuggestions = (inputValue) =>{
		GetData(`get/place?text=${inputValue}`).then((result) => {
			console.log('suggestions', result.suggestions.predictions)
            this.setState({suggestions: result.suggestions.predictions, isSuggestionsVisible: true })
        });
	// 	this.setState({suggestions: [
    //     {
    //         "description": "Delhi, India",
    //         "matched_substrings": [
    //             {
    //                 "length": 3,
    //                 "offset": 0
    //             }
    //         ],
    //         "place_id": "ChIJLbZ-NFv9DDkRQJY4FbcFcgM",
    //         "reference": "ChIJLbZ-NFv9DDkRQJY4FbcFcgM",
    //         "structured_formatting": {
    //             "main_text": "Delhi",
    //             "main_text_matched_substrings": [
    //                 {
    //                     "length": 3,
    //                     "offset": 0
    //                 }
    //             ],
    //             "secondary_text": "India"
    //         },
    //         "terms": [
    //             {
    //                 "offset": 0,
    //                 "value": "Delhi"
    //             },
    //             {
    //                 "offset": 7,
    //                 "value": "India"
    //             }
    //         ],
    //         "types": [
    //             "administrative_area_level_1",
    //             "political",
    //             "geocode"
    //         ]
    //     },
    //     {
    //         "description": "Delaware, USA",
    //         "matched_substrings": [
    //             {
    //                 "length": 3,
    //                 "offset": 0
    //             }
    //         ],
    //         "place_id": "ChIJO9YMTXYFx4kReOgEjBItHZQ",
    //         "reference": "ChIJO9YMTXYFx4kReOgEjBItHZQ",
    //         "structured_formatting": {
    //             "main_text": "Delaware",
    //             "main_text_matched_substrings": [
    //                 {
    //                     "length": 3,
    //                     "offset": 0
    //                 }
    //             ],
    //             "secondary_text": "USA"
    //         },
    //         "terms": [
    //             {
    //                 "offset": 0,
    //                 "value": "Delaware"
    //             },
    //             {
    //                 "offset": 10,
    //                 "value": "USA"
    //             }
    //         ],
    //         "types": [
    //             "geocode",
    //             "political",
    //             "administrative_area_level_1"
    //         ]
    //     },
    //     {
    //         "description": "Delft, Netherlands",
    //         "matched_substrings": [
    //             {
    //                 "length": 3,
    //                 "offset": 0
    //             }
    //         ],
    //         "place_id": "ChIJ_VhfUcO1xUcRPdRLxaNcsIk",
    //         "reference": "ChIJ_VhfUcO1xUcRPdRLxaNcsIk",
    //         "structured_formatting": {
    //             "main_text": "Delft",
    //             "main_text_matched_substrings": [
    //                 {
    //                     "length": 3,
    //                     "offset": 0
    //                 }
    //             ],
    //             "secondary_text": "Netherlands"
    //         },
    //         "terms": [
    //             {
    //                 "offset": 0,
    //                 "value": "Delft"
    //             },
    //             {
    //                 "offset": 7,
    //                 "value": "Netherlands"
    //             }
    //         ],
    //         "types": [
    //             "geocode",
    //             "political",
    //             "locality"
    //         ]
    //     },
    //     {
    //         "description": "Delhi cantt railway Junction, Kirby Place, Delhi Cantonment, New Delhi, Delhi, India",
    //         "matched_substrings": [
    //             {
    //                 "length": 3,
    //                 "offset": 0
    //             }
    //         ],
    //         "place_id": "ChIJe511hdAdDTkRy4vPSu2VEQk",
    //         "reference": "ChIJe511hdAdDTkRy4vPSu2VEQk",
    //         "structured_formatting": {
    //             "main_text": "Delhi cantt railway Junction",
    //             "main_text_matched_substrings": [
    //                 {
    //                     "length": 3,
    //                     "offset": 0
    //                 }
    //             ],
    //             "secondary_text": "Kirby Place, Delhi Cantonment, New Delhi, Delhi, India"
    //         },
    //         "terms": [
    //             {
    //                 "offset": 0,
    //                 "value": "Delhi cantt railway Junction"
    //             },
    //             {
    //                 "offset": 30,
    //                 "value": "Kirby Place"
    //             },
    //             {
    //                 "offset": 43,
    //                 "value": "Delhi Cantonment"
    //             },
    //             {
    //                 "offset": 61,
    //                 "value": "New Delhi"
    //             },
    //             {
    //                 "offset": 72,
    //                 "value": "Delhi"
    //             },
    //             {
    //                 "offset": 79,
    //                 "value": "India"
    //             }
    //         ],
    //         "types": [
    //             "point_of_interest",
    //             "establishment"
    //         ]
    //     },
    //     {
    //         "description": "Delray Beach, FL, USA",
    //         "matched_substrings": [
    //             {
    //                 "length": 3,
    //                 "offset": 0
    //             }
    //         ],
    //         "place_id": "ChIJ42rskPzf2IgRuLhuUygBeMc",
    //         "reference": "ChIJ42rskPzf2IgRuLhuUygBeMc",
    //         "structured_formatting": {
    //             "main_text": "Delray Beach",
    //             "main_text_matched_substrings": [
    //                 {
    //                     "length": 3,
    //                     "offset": 0
    //                 }
    //             ],
    //             "secondary_text": "FL, USA"
    //         },
    //         "terms": [
    //             {
    //                 "offset": 0,
    //                 "value": "Delray Beach"
    //             },
    //             {
    //                 "offset": 14,
    //                 "value": "FL"
    //             },
    //             {
    //                 "offset": 18,
    //                 "value": "USA"
    //             }
    //         ],
    //         "types": [
    //             "locality",
    //             "geocode",
    //             "political"
    //         ]
    //     }
    // ], isSuggestionsVisible: true })
	}

	// Handle input focus
	handleFocus = () => {
		if (this.state.suggestions.length > 0) {
		  this.setState({ isSuggestionsVisible: true });
		}
	};

    onChange(e){
        const target = e.target;
        const value = target.type === 'checkbox' ? target.value : target.value;
        const name = target.name;
        //console.log('this state===',name,value);
        this.setState({[name]:value});    
    } 
    isSubscriberChange(e){
        this.setState({[e.target.name]:e.target.value});
        console.log('e.target.value==',e.target.value);
            if(e.target.value==='yes')
            {
                this.setState({isshowing_subscription_hour:true});
                this.setState({isshowing_org_credit:false});
                //this.setState({org_credit:''});
            }
            else if(e.target.value==='no')
            {
                this.setState({isshowing_org_credit:true});
                this.setState({isshowing_subscription_hour:false});
                //this.setState({subscription_hour:''});
            }		
        }
    async submit(e) {
        e.preventDefault();
        if (this.validateForm())
        {
            let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data
			// console.log('userdata', userdata);
            const data = new FormData();
            if(!this.state.vimeo_uri){
                const response = await fetch(
                    'https://api.vimeo.com/users/70047375/projects',
                    {
                        method: 'POST',
                        headers: {
                            Authorization: `bearer `+Configdata.vimeo.AuthToken,//old 0c909954139c00b4b07af0ce71811f3d
                            'content-type': 'application/json',
                        },
                        body: JSON.stringify({
                            name : this.state.org_name,
                        }),
                    }
                );
                const resdata = await response.json();
                data.append('vimeo_uri', resdata.uri)
            }
            console.log('this.state.credits==',this.state.credits);		
            
            data.append('org_logo', this.state.logo)
            data.append('org_name', this.state.org_name)
            data.append('street', this.state.street)
            data.append('city', this.state.city)
            data.append('state', this.state.state)
            data.append('zip', this.state.zip)
            data.append('phone', this.state.phone)
            data.append('twitter', this.state.twitter)
            data.append('linkedin', this.state.linkedin)
            data.append('subscriber', this.state.subscriber)
            data.append('subscriberType', this.state.subscriberType)
            data.append('subscription_hour', this.state.subscription_hour)
            data.append('remaining_hours', this.state.remaining_hours)
            data.append('totalavailable_hours', this.state.totalavailable_hours)//totalavailable_hours
            data.append('subscription_hour_rate', this.state.subscription_hour_rate)//subscription_hour_rate
            data.append('hours_renew_date', this.state.hours_renew_date)//totalavailable_hours
            data.append('credits', this.state.credits)
            data.append('boxfolderid', this.state.boxfolderid)
            data.append('nick_name', this.state.nick_name)
            data.append('website', this.state.website)
            data.append('freshbook_profile_id', this.state.freshbookprofileid)
            data.append('note', this.state.note)
   			// data.append('teammember', this.state.teammember )
   			// data.append('tduedate', this.state.dueDate)
   			// data.append('puserid', userdata.user.ID);
   			// data.append('assignUserid', this.state.selectedTeamMemberId);
            
            if(this.state.selectedIndustry == "Others") {
				data.append('industry', this.state.selectedIndustry);
				data.append('otherIndustry', this.state.otherIndustry);
			} else {
				data.append('industry', this.state.selectedIndustry);
			}
   			data.append('fiscalYear', this.state.fiscalYearStart);
   			data.append('opportunities', JSON.stringify(this.state.opportunities));

            let session_key = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data.token;
            // console.log('data======this.state.street=',this.state.street);
            // console.log('data======this.state.street=',this.state.street);
		    // console.log('data======this.state.c=',this.state.city);
		    // console.log('data======this.state.s=',this.state.state);
            fetch(apiConfig.WEB_SERVICE_URL+'organizationstg/'+this.props.match.params.id, {
            method: 'POST',
            body: data,
            headers: {
                    "session-key": session_key,
                }
            })
            .then((response) => response.json())
            .then((res) => {
                if(res.statuscode===200)
                // this.setState({success:'Organization Updated Successfully!!'}); 
                toast.success('Organization Updated Successfully!!'); 
                else
                toast.error('Something went wrong'); 
                // this.setState({success:'Something went wrong'}); 
                //this.props.history.push("/organization/list");
            });
        }    
    }
    validateForm() {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;
        if (!fields["org_name"]) {
            formIsValid = false;
            errors["org_name"] = "*Please enter your Organization Name";
        }
        if (typeof fields["zip"] !== "undefined") {
            //regular expression for email validation
            var zip = /^[0-9]{5}(?:-[0-9]{4})?$/;
            if (!zip.test(fields["zip"])) {
            formIsValid = false;
            errors["zip"] = "*Please enter valid zip code.";
            }
        }
        if (typeof fields["phone"] !== "undefined") {
            //regular expression for email validation
            var phoneNum = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/; 
            if (!phoneNum.test(fields["phone"])) {
            formIsValid = false;
            errors["phone"] = "*Please enter valid phone number.";
            }
        }  
        
        if (!fields["subscriber"]) {
            formIsValid = false;
            errors["subscriber"] = "*Please select subscriber";
            console.log('formIsValid=',formIsValid);
        }
        // if (!fields["subscriberType"]) {
        //     formIsValid = false;
        //     errors["subscriberType"] = "*Please select subscriber type";
        //     console.log('formIsValid=',formIsValid);
        // }
        this.setState({
            errors: errors
        });
        return formIsValid;
    }
    handleDateChange(e) {
		this.setState({ hours_renew_date: e.target.value });
	}
    handleSubscriberChange(e) {
        if(e.target.value == 'demo' || e.target.value == 'subscriber') {            
            this.setState({ subscriberType: e.target.value, subscriber: 'yes', isshowing_subscription_hour:true, isshowing_org_credit:false });
        } else {
            this.setState({ subscriberType: e.target.value, subscriber: 'no', isshowing_org_credit:true, isshowing_subscription_hour:false });
        }
	}
    createTaskUI() {
		const CustomButton = ({ value, onClick }) => (
			<div className="calendar-div">
				<button className="example-custom-input" onClick={onClick}>
					<img src={dueDateImage} />
				</button>
				<div>{value}</div>
			</div>
		);
		
		const assocteammembers = [];
		const associatedteammemebers = this.state.teamMemberList;
		if (associatedteammemebers) {
			for (var key in associatedteammemebers) {
				let display_name=associatedteammemebers[key].first_name+' '+ associatedteammemebers[key].last_name
				assocteammembers.push(<option data-id={associatedteammemebers[key].ID} value={display_name}>{display_name}</option>)
			}
		}
		return (
			<div className="">
				<div>
					<label>Select Team Member</label>
					<div className="">
						{/* <img class="SelectIconLeft" src={require('../../../assets/images/upload-icon.png')} /> */}
						<select name="teammember" className="form-control" value={this.state.teammember} onChange={this.handleTeamMemberChange.bind(this)} id="subscription_hour">
							<option value=" ">Select Team Member</option>
							{assocteammembers}
						</select>
                        {this.state.teamUserError && <div>{this.state.teamUserError}</div>}
					</div>
				</div>
				{/* <div className="col-12 col-sm-12 col-md-3 col-lg-3 LeftLocation">
					<select name="assignment" className="form-control" id="assignment">
						<option value=" ">Select Assignment</option>
						<option value="customer follow up">Customer Follow Up</option>
					</select>
				</div> */}
				<div>
					<div className="follow-up-main">
						<label>Follow Up Date:</label>
						<h4>					
							<DatePicker className="form-control" selected={this.state.dueDate}
								name="tduedate"
								minDate={moment().toDate()}
								onChange={date => this.handleTaskDueDateChange('tduedate', date)}
								dateFormat="d MMMM yyyy"
								customInput={<CustomButton />}
							/>
						</h4>
					</div>
                    {this.state.dueDateError && <div>{this.state.dueDateError}</div>}
				</div>
			</div>
		)
	}

    handleTaskClose(value, e) {
        this.setState({
            showFollowUpTaskModal: value,
        });
    }
    handleTaskSave() {
        if(this.validateTaskForm()) {
            let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data
            
            if(this.state.isAlreadyAssignedTask) {
                let data= {
                    teammember: this.state.teammember,
                    tduedate: this.state.dueDate,
                    org_id: this.props.match.params.id,
                    puserid: userdata.user.ID,
                    assignUserid: this.state.selectedTeamMemberId,
                    isTaskExists: this.state.isAlreadyAssignedTask,
                    taskId: this.state.taskDetail._id
                }
                console.log('data if', data)
                PutData(`update/followup/task`, data).then(async (result) => {
                    console.log('result==',result);
                    toast.success('Follow up task Updated successfully..');
                });
            } else {
                let data = {
                    teammember: this.state.teammember,
                    tduedate: this.state.dueDate,
                    org_id: this.props.match.params.id,
                    puserid: userdata.user.ID,
                    assignUserid:this.state.selectedTeamMemberId
                }
                console.log('data else', data)
                PostData('create/followup/task', data).then(async (result) => {
                    console.log('result== follow up',result);
                    toast.success('Follow up task created successfully..');
                });
            }
        }
    }
    validateTaskForm() {
        let formIsValid = true;
		if(this.state.teammember && this.state.teammember !== "" && this.state.dueDate){
			this.setState({showFollowUpTaskModal: false, teamUserError: "", dueDateError: "", assignedUser: this.state.teammember});
		}else if(this.state.teammember && this.state.teammember != "") {
			if(!this.state.dueDate){				
				this.setState({dueDateError: 'Date is required'});
                formIsValid = false
			}
		} else if(this.state.dueDate){
			if(!this.state.teammember && this.state.teammember == ""){
				this.setState({teamUserError: 'Please select team member'});
                formIsValid = false
			}
		} else if(!this.state.teammember && !this.state.dueDate && this.state.teammember == "") {
			this.setState({ dueDateError: 'Date is required', teamUserError: 'Please select team member' });
            formIsValid = false
		}

        return formIsValid
	}

    handleTeamMemberChange( e) {
		var index = e.target.selectedIndex;
		var optionElement = e.target.childNodes[index]
		var option = optionElement.getAttribute('data-id');
		// console.log('option-------', option)
		// console.log('e.target.value-------', e.target.value)
		this.setState({ selectedTeamMemberId: option, teammember: e.target.value });
	}

    handleTaskDueDateChange(name, date, i) {
		// console.log('date----', date)
		this.setState({  dueDate: date });
	}

    handleChangeOpportunity = (event) => {
		const { name, value } = event.target;
		this.setState({ [name]: value });
	};

    // Add a new opportunity to the list
    addOpportunity = () => {
        const { opportunityName, opportunityMonth, opportunities, selectedOrgContact, selectedOrgContactId } = this.state;
    
        if (opportunityName && opportunityMonth) {
          const newOpportunity = {
            name: opportunityName,
            opportunityMonth,
            orgContactName: selectedOrgContact,
            orgContactId: selectedOrgContactId
          };
    
          this.setState({
            opportunities: [...opportunities, newOpportunity],
            opportunityName: '',
            opportunityMonth: '',
            selectedOrgContact: '',
            selectedOrgContactId: '',
          });
          this.setState((prevState) =>({
            errors: {
                ...prevState.errors, 
                videoOpportunityError: "",
                videoOpportunityMonth: "",
            },
          }))
        //   toast.success("Opportunity added successfully")
        } else {
        //   alert('Please provide both opportunity name and reminder date.');
          this.setState((prevState) =>({
            errors: {
                ...prevState.errors,
                videoOpportunityError: "Please provide opportunity name",
                videoOpportunityMonth: "Please provide opportunity month",
            },
          }))
        }
      };
    //   addOpportunity = () => {
    //     const { opportunityName, reminderDate, opportunities } = this.state;
    
    //     if (opportunityName && reminderDate) {
    //       const newOpportunity = {
    //         name: opportunityName,
    //         reminderDate,
    //       };
    
    //       this.setState({
    //         opportunities: [...opportunities, newOpportunity],
    //         opportunityName: '',
    //         reminderDate: '',
    //       });
    //       this.setState((prevState) =>({
    //         errors: {
    //             ...prevState.errors, 
    //             videoOpportunityError: "",
    //             videoOpportunityDate: "",
    //         },
    //       }))
    //     //   toast.success("Opportunity added successfully")
    //     } else {
    //     //   alert('Please provide both opportunity name and reminder date.');
    //       this.setState((prevState) =>({
    //         errors: {
    //             ...prevState.errors,
    //             videoOpportunityError: "Please provide opportunity name",
    //             videoOpportunityDate: "Please provide opportunity reminder date",
    //         },
    //       }))
    //     }
    //   };

      handleFiscalYearChange = (event) => {
		this.setState({ fiscalYearStart: event.target.value });
	};

    handleOpportunityMonthChange = (event) => {
		this.setState({ opportunityMonth: event.target.value });
	};
    handleOrgContactChange = (event) => {
        // const userInfo = event.target.value
        console.log('event.target.value', event.target.value)
        const userInfo = this.state.orgContactList.find(user => user._id === event.target.value);
		this.setState({ selectedOrgContact: `${userInfo.first_name} ${userInfo.last_name}`, selectedOrgContactId: userInfo._id });
	};

    handleIndustryChange(e) {
        this.setState({ selectedIndustry: e.target.value, selectedIndustryWithLowerCase: e.target.value.toLowerCase() });
	}

    // Handle deleting an opportunity
	handleDeleteOpportunity = (index) => {
		this.setState((prevState) => ({
			opportunities: prevState.opportunities.filter(
			  (_, i) => i !== index
			),
		}));
	};
    

    render() {
        const isshowing_subscription_hour=this.state.isshowing_subscription_hour;
        const isshowing_org_credit=this.state.isshowing_org_credit;
        const subscriber = this.state.subscriber;
        const succesmsg = this.state.success;
        let subscribed;
        let notsubscribed;
        if(subscriber)
        {
            if (subscriber=='yes') {
                subscribed = true;
                notsubscribed = false;
            } else {
                notsubscribed = true;
                subscribed = false;
            } 
        }
        const ExampleCustomInputForDuedate = ({ value, onClick }) => (
			<button className="example-custom-input" onClick={onClick}>
                <div>
                    Due {value}
                </div>
			</button>
		);
        const dates = this.state.dates.map(i => (
        <option key={i.date} value={i.date}>
            { i.date }		      
        </option>
        ));
        const subscriberType = this.state.subscriberTypeList.map(i => (
            <option key={i.id} value={i.value}>
                { i.type }
            </option>
        ));

        const industryType = this.state.industries.map(i => (
            <option key={i} value={i}>
                { i }
            </option>
        ));

		const { opportunityName, reminderDate, opportunities, suggestions, isSuggestionsVisible } = this.state;

        return (
            <div className="container-fluid create-organization">
                <div class="row wrapper-box">
                    <div className="panel panel-primary">                    
                        <div className="panel-heading">
                            <div className="row create-org-header">
                                <div className="">
                                    <h4 class="PageBarTitle">Update Organization</h4>
                                </div>
                                <div className="create-task-org">
                                {/* </div>
                                <div className="col-md-2 col-lg-2 pull-right create-task-org"> */}
                                    <div>
                                        <button className="UpdateBtn btn btn-primary" onClick={this.handleTaskClose.bind(this, true)}>Create Task</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="panel-body">
                            <p style={successMsg}>{succesmsg}</p>
                            <div onSubmit={this.onSubmit} class="FormDesign">
                                <div className="form-label-group">
                                    <label htmlFor="org">Organization</label>
                                    <input type="text" name="org_name" value={this.state.org_name}
                                        onChange={this.onChange} className="form-control" autoFocus /> 
                                    <div style={errorMsg}>{this.state.errors.org_name}</div>                 
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <label htmlFor="street">Street</label>
                                        {/* <input type="text" name="street" value={this.state.street}
                                        onChange={this.onChange} className="form-control" autoFocus />   */}
                                        <input 
                                            type="text"
                                            name="street"
                                            value={this.state.street}
                                            onChange={this.handleAddressInput}
                                            onFocus={this.handleFocus}
                                            ref={this.inputRef}
                                            autoComplete="off"
                                            className="form-control"
                                            autoFocus
                                        />
                                        { isSuggestionsVisible && suggestions.length > 0 && (
                                            // <ul style={{ border: '1px solid #ccc', padding: '0', margin: '0', maxHeight: '200px', overflowY: 'auto' }}>
                                            <ul ref={this.suggestionsRef} className="address-suggestion-ul">
                                                {suggestions.map((suggestion, index) => (
                                                <li
                                                    key={index}
                                                    onClick={() => this.handleAddressSelect(suggestion)}
                                                >
                                                    {suggestion.description}
                                                </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    <div className="col-sm-4">
                                        <label htmlFor="city">City</label>
                                        <input type="text" name="city" value={this.state.city}
                                        onChange={this.onChange} className="form-control" autoFocus />  
                                    </div>
                                    <div className="col-sm-4">
                                        <label htmlFor="state">State</label>
                                        <input type="text" name="state"  value={this.state.state}
                                            onChange={this.onChange} className="form-control" autoFocus />                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                    <label htmlFor="zip">Zip</label>
                                    <input type="text" name="zip" value={this.state.zip}
                                        onChange={this.onChange} className="form-control" autoFocus /> 
                                    <div style={errorMsg}>{this.state.errors.zip}</div>                    
                                    </div>
                                    <div className="col-sm-4">
                                    <label htmlFor="phone">Phone</label>
                                    <input type="text" name="phone"  value={this.state.phone}
                                        onChange={this.onChange} className="form-control" autoFocus />  
                                    <div style={errorMsg}>{this.state.errors.phone}</div>                   
                                    </div>
                                    <div className="col-sm-4">
                                    <label htmlFor="twitter">Twitter</label>
                                    <input type="text" name="twitter" value={this.state.twitter}
                                        onChange={this.onChange} className="form-control" autoFocus />                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                    <label htmlFor="linkedin">LinkedIn</label>
                                    <input type="text" name="linkedin" value={this.state.linkedin}
                                        onChange={this.onChange} className="form-control" autoFocus />                    
                                    </div>
                                    <div className="col-sm-4">
                                    <label htmlFor="logo">Upload Logo</label>
                                    <input type="file" name="logo" onChange={this.onChangeHandler} className="form-control" autoFocus />
                                    </div>
                                    <div className="col-sm-4">
                                        <label htmlFor="issubscriber">Subscriber</label><br/>
                                        {/* <label className="radio-inline">
                                            <input type="radio" name="subscriber" defaultChecked={subscribed} onChange={this.isSubscriberChange} value="yes"/>Yes
                                        </label>
                                        <label className="radio-inline">
                                            <input type="radio" name="subscriber" defaultChecked={notsubscribed} onChange={this.isSubscriberChange} value="no" />No
                                        </label> */}
                                        <select name="subscriberType" className="form-control" value={this.state.subscriberType} onChange={this.handleSubscriberChange.bind(this)} >
                                            <option value="">Select </option>
                                            {subscriberType}							
                                        </select>
                                        {/* <div style={errorMsg}>{this.state.errors.subscriberType}</div>       */}
                                    </div>
                                </div>
                                
                                <div className="form-label-group">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label htmlFor="fiscal-year-dropdown">
                                                Fiscal Year:
                                            </label>
                                            <br />
                                            <select
                                                // id="fiscal-year-dropdown"
                                                className="form-control"
                                                value={this.state.fiscalYearStart}
                                                onChange={this.handleFiscalYearChange}
                                            // style={{ marginTop: '10px', padding: '8px', width: '300px', fontSize: '16px' }}
                                            >
                                                <option value="" disabled> Select a month </option>
                                                {this.state.months.map((month, index) => (
                                                    <option key={index} value={month}>
                                                        {month}
                                                    </option>
                                                ))}
                                                {/* {fiscalMonths} */}
                                            </select>
                                            {/* <div className="errorMsg">{this.state.errors.industryType}</div> */}
                                        </div>
                                        <div className="col-sm-6">
                                            <label htmlFor="issubscriber">Industry</label><br />
                                            <select name="industry" className="form-control" value={this.state.selectedIndustry} onChange={this.handleIndustryChange.bind(this)} >
                                                <option value="">Select </option>
                                                {industryType}
                                            </select>
                                            {/* <div className="errorMsg">{this.state.errors.industryType}</div> */}
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="form-label-group">
			</div> */}
                                {this.state.selectedIndustry == 'Others' &&
                                    <div >
                                        <label htmlFor="specific_industry">Specify Other Industry</label>
                                        <input type="text" name="otherIndustry" value={this.state.otherIndustry} onChange={this.onChange} className="form-control" autoFocus />
                                    </div>
                                }


                                <div className="row">
                                    <div className="col-sm-6">
                                        <label htmlFor="subscription_hour">Acronym/Nick Name</label>
                                        <input type="text" value={this.state.nick_name} name="nick_name" onChange={this.onChange} className="form-control" autoFocus />
                                    </div>
                                    <div className="col-sm-6">
                                        <label htmlFor="subscription_hour">Website</label>
                                        <input type="text" value={this.state.website} name="website" onChange={this.onChange} className="form-control" autoFocus />
                                    </div>
                                </div>
                                
                                    {
                                        isshowing_subscription_hour &&
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label htmlFor="subscription_hour">Subscription (In Hrs/Month )</label>
                                                <input type="number" value={this.state.subscription_hour} name="subscription_hour" onChange={this.onChange} className="form-control" autoFocus />
                                            </div>
                                            <div className="col-sm-6">
                                                <label htmlFor="subscription_hour">Hours Renew Date </label>                                                
                                                <select name="taskstatus" className="form-control" value={this.state.hours_renew_date} onChange={this.handleDateChange.bind(this)} >
                                                    <option value=" ">Select Date</option>
                                                    {dates}							
                                                </select>
                                                {/* <DatePicker className="form-control"
                                                    selected={new Date(this.state.hours_renew_date)}
                                                    name="hours_renew_date"
                                                    onChange={this.handleChange}
                                                    dateFormat="MM/dd/yyyy"		
                                                />				 */}
                                            </div>
                                        </div>     
                                                   
                                    }
                                    

                                    {
                                        isshowing_subscription_hour &&
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label htmlFor="subscription_hour">Total Remaining Hours (In Hrs:Min )</label>
                                                <input type="text" value={this.state.totalavailable_hours} name="totalavailable_hours" onChange={this.onChange} className="form-control" autoFocus />
                                            </div> 
                                            <div className="col-sm-6">
                                                <label htmlFor="subscription_hour">Monthly Remaining Hours (In Hrs:Min )</label>
                                                <input type="text" value={this.state.remaining_hours} name="remaining_hours" onChange={this.onChange} className="form-control" autoFocus />
                                            </div> 
                                            <div className="col-sm-12">
                                                <label htmlFor="subscription_hour">Subscribed Hourly Rate </label>
                                                <input type="number" value={this.state.subscription_hour_rate} name="subscription_hour_rate" onChange={this.onChange} className="form-control" autoFocus />
                                            </div>   
                                        </div>                                        
                                    }
                                <div className="row">
                                    { isshowing_org_credit &&
                                        <div className="col-sm-6">
                                            <label htmlFor="org_credit">Organization Credit</label>
                                            <input type="text" value={this.state.credits} onChange={this.isSubscriberChange} className="form-control" name="credits" id="org_credit"/>
                                        </div>    
                                    }
                                    
                                    <div className="col-sm-6">
                                        <label htmlFor="linkedin">Box Folder ID</label>
                                        <input type="text" name="boxfolderid" value={this.state.boxfolderid}  onChange={this.onChange} className="form-control" autoFocus />
                                    </div>   
                                    <div className={isshowing_org_credit?'col-sm-12':'col-sm-6'}>
                                        <label htmlFor="linkedin">Freshbook Profile ID</label>
                                        <input type="text" name="freshbookprofileid" value={this.state.freshbookprofileid}  onChange={this.onChange} className="form-control" autoFocus />
                                    </div>
                                    
                                </div>

                                <label htmlFor="video_opportunities">Video Opportunities</label>
                                <div className="row">
                                    {/* Input Fields */}
                                    <div className="col-sm-5" style={{marginBottom: '10px'}}>
                                        <input
                                            type="text"
                                            name="opportunityName"
                                            className="form-control"
                                            style={{marginBottom: '0px'}}
                                            placeholder="Opportunity Name"
                                            value={opportunityName}
                                            onChange={this.handleChangeOpportunity}
                                        />
                                        {this.state.videoOpportunityError != "" && <div className="errorMsg">{this.state.errors.videoOpportunityError}</div>}
                                    </div>
                                    <div className="col-sm-2" style={{marginBottom: '10px'}}>
                                        <select
                                            // id="fiscal-year-dropdown"
                                            className="form-control"
                                            value={this.state.opportunityMonth}
                                            onChange={this.handleOpportunityMonthChange}
                                        // style={{ marginTop: '10px', padding: '8px', width: '300px', fontSize: '16px' }}
                                        >
                                            <option value="" disabled> Select a month </option>
                                            {this.state.months.map((month, index) => (
                                                <option key={index} value={month}>
                                                    {month}
                                                </option>
                                            ))}
                                            {/* {fiscalMonths} */}
                                        </select>
                                        {this.state.videoOpportunityMonth != "" && <div className="errorMsg">{this.state.errors.videoOpportunityMonth}</div>}
                                    </div>
                                    {
                                        this.state.orgContactList && this.state.orgContactList.length > 0 &&
                                        <div className="col-sm-3" style={{marginBottom: '10px'}}>
                                            <select
                                                // id="fiscal-year-dropdown"
                                                className="form-control"
                                                value={this.state.selectedOrgContactId}
                                                onChange={this.handleOrgContactChange}
                                            // style={{ marginTop: '10px', padding: '8px', width: '300px', fontSize: '16px' }}
                                            >
                                                <option value="" disabled> Select Organization Contact </option>
                                                {this.state.orgContactList.map((user, index) => (
                                                    <option key={index} value={user._id}>
                                                        {`${user.first_name} ${user.last_name}`}
                                                    </option>
                                                ))}
                                                {/* {fiscalMonths} */}
                                            </select>
                                            {/* {this.state.videoOpportunityMonth != "" && <div className="errorMsg">{this.state.errors.videoOpportunityMonth}</div>} */}
                                        </div>
                                    }
                                    {/* <div className="col-sm-3" style={{marginBottom: '10px'}}>
                                        <input
                                            type="date"
                                            name="reminderDate"
                                            className="form-control"
                                            style={{marginBottom: '0px'}}
                                            value={reminderDate}
                                            onChange={this.handleChangeOpportunity}
                                        />
                                        {this.state.videoOpportunityDate != "" && <div className="errorMsg">{this.state.errors.videoOpportunityDate}</div>}
                                    </div> */}
                                    <div className="col-sm-2">
                                        <button type="button" className="UpdateBtn btn btn-primary" onClick={this.addOpportunity}>Add Opportunity</button>
                                    </div>
                                    {/* <div className="col-sm-1.5">
                                        <button type="button" className="UpdateBtn btn btn-primary" onClick={()=>{this.handleOpportunityModal(true)}}>Check Opportunities</button>
                                    </div> */}

                                    {/* <div className="col-sm-1.5">
                                        {opportunities.map((opportunity, index) => (
                                            <p key={index}>
                                                <span> {opportunity.name} </span> <span> - </span>  <span> {new Date(opportunity.reminderDate).toLocaleDateString()} </span>
                                            </p>
                                        ))}
                                    </div> */}
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    {opportunities.map((opportunity, index) => (
                                        <li style={styles.listItem}>
                                            <span style={styles.name}>{opportunity.name}</span>
                                            <span style={styles.date}>{opportunity.opportunityMonth}</span>
                                            <span style={styles.date}>{opportunity.orgContactName}</span>
                                            <button
                                                type="button"
                                                onClick={() => this.handleDeleteOpportunity(index)}
                                                style={styles.deleteButton}
                                            >
                                                🗑️ 
                                            </button>
                                        </li>
                                    ))}
                                </div>
                                {/* <div style={{ marginBottom: '20px' }}>
                                    {opportunities.map((opportunity, index) => (
                                        <li style={styles.listItem}>
                                            <span style={styles.name}>{opportunity.name}</span>
                                            <span style={styles.date}>{opportunity.reminderDate}</span>
                                            <button
                                                type="button"
                                                onClick={() => this.handleDeleteOpportunity(index)}
                                                style={styles.deleteButton}
                                            >
                                                🗑️ 
                                            </button>
                                        </li>
                                    ))}
                                </div> */}

                                <div className="form-label-group">
                                    <label htmlFor="note">Note</label>
                                    <input type="text" name="note" value={this.state.note}
                                        onChange={this.onChange} className="form-control" autoFocus />
                                    {/* <div style={errorMsg}>{this.state.errors.note}</div>                  */}
                                </div>
                                <div className="row followUp-assign">
                                    <div className="">
                                        Follow up assigned to: &nbsp;
                                    </div>
                                    <div className="">
                                        {` ${this.state.assignedUser}`}
                                    </div>
                                </div>
                                <div className="form-group">
                                    <input type="submit" onClick={this.submit}
                                        value="Update Organization" 
                                        className="UpdateBtn btn btn-primary"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal show={this.state.showFollowUpTaskModal} size="lg" >
					<Modal.Header class="SelectProducerHead">
						<Modal.Title>Create Follow-Up Task</Modal.Title>
					</Modal.Header>
					<Modal.Body className="SelectProducerModel addtasktime">
						<div className="row">
							<div className="col-12">
								{/* <label></label> */}
								{/* <label>Create a follow-up task to keep track of your customer interactions ?</label> */}
								<div className="checkbox">
									{/* <div className="col-12 col-sm-12 col-md-3 col-lg-3 LeftPurpose"> */}
										{/* <img class="SelectIconLeft" src={require('../../../assets/images/upload-icon.png')} /> */}
										{/* <select name="teammember" className="form-control" onChange={this.handleTeamMemberChange.bind(this, i)} id="subscription_hour">
											<option value=" ">Select Team Member</option>
											{assocteammembers}
										</select> */}
									{/* </div> */}

									{/* <div className="col-12 col-sm-12 col-md-3 col-lg-3 LeftLocation align-left">
										<h4>Follow Up Date
											<DatePicker className="form-control" selected={this.state.dueDate}
												name="tduedate"
												minDate={moment().toDate()}
												onChange={date => this.handleTaskDueDateChange('tduedate', date)}
												dateFormat="d MMMM"
												customInput={<CustomButton />} />
										</h4>
									</div> */}
									{this.createTaskUI()}
								</div>										
							</div>
						</div><br/>					
					</Modal.Body>
					<Modal.Footer class="FullWidthModelFoot">
						<Button variant="secondary" onClick={this.handleTaskClose.bind(this, false)}>
							X
						</Button>
						<Button className="okbtn" variant="primary" onClick={this.handleTaskSave.bind(this)}>
							Save
						</Button>
						<Button variant="primary" onClick={this.handleTaskClose.bind(this, false)}>
							Cancel
						</Button>
					</Modal.Footer>
				</Modal>
            </div>
        )
    }
}